import axios, { AxiosResponse } from 'axios';
import { isBlogPage, extractPreviewContent } from './helpers';
import { IBlogPreviewContent, IPage } from './interfaces';

type TReturnType = 'pages';

const URL = process.env.EXTERNAL_BLOG_GRAPHQL || process.env.REACT_APP_EXTERNAL_BLOG_GRAPHQL;

class ExternalBlog {
    private getGQLData(query: string, returnData?: TReturnType) {
        return axios({
            method: 'post',
            url: URL,
            headers: {
              'content-type': 'application/json',
            },
            data: JSON.stringify({
              operationName: null,
              variables: {},
              query,
            }),
          })
          .then((res: AxiosResponse) => {
            if (res.data && res.data.errors) {
              const err = new Error('Error during GraphQL communication');
              (err as any).response = {data: res.data};
              throw err;
            }
            if (returnData) {
                if (res.data && res.data.data && res.data.data[returnData]) {
                    return res.data.data[returnData];
                }
            } else {
                return res.data;
            }
          })
          .catch(e => {
            if (e.response) {
              console.error('EXTERNAL BLOG ERROR', e, e.response.status, e.response.data);
            } else {
              console.log(e);
            }
            throw new Error(e);
          });
    }

    // k získání Tagů je potřeba access token, takže toto vrací chybu 403
    public async getTags() {
        const query = `query Tags {
            tags {
                id
                name
            }
        }`;

        const tags = await this.getGQLData(query);
        console.dir(tags, {depth: null});
    }

    public async getPageTags(): Promise<string[]> {
        const query = `query AllPages {
            pages {
              id
              tags {
                id
                name
                color
              }
            }
          }`;

        const pages = await this.getGQLData(query, 'pages');
        if (!Array.isArray(pages)) {
            return [];
        }

        const foundTags: string[] = pages.reduce((acc: string[], page) => {
            if (Array.isArray(page.tags)) {
                for (const tag of page.tags) {
                    if (tag && tag.name) {
                        if (acc.indexOf(tag.name) < 0) {
                            acc.push(tag.name);
                        }
                    }
                }
            }
            return acc;
        }, []);

        return foundTags;
    }

    public async getPagesByTags(tags: string[], languageCode?: string) {
      const query = `query TaggedPages {
        pages (where: {tags_some:{name_in:["${tags.join('","')}"]}}) {
          id
          type {
            id
            name
          }
          tags {
            id
            name
          }
          translations${'string' === typeof languageCode ? `(where:{language:{code: "${languageCode}"}})` : ''} {
            id
            name
            url
            content
            language {
              id
              code
              name
              englishName
            }
            annotations { #mezi anotacemi je uložený obrázek
              id
              key
              value
            }
          }
          createdAt
        }
      }`;

      const pages = await this.getGQLData(query, 'pages');
      return pages;
    }

    public async getBlogPagesByTags(tags: string[], languageCode?: string) {
      const pages = await this.getPagesByTags(tags, languageCode);

      const blogs = pages.filter((p: IPage) => isBlogPage(p.translations));

      return blogs;
    }

    public async getPreviewBlogContentsByTags(tags: string[], languageCode?: string): Promise<IBlogPreviewContent[]> {
      const blogs = await this.getBlogPagesByTags(tags, languageCode);
      const previewContent = blogs.map((blog: IPage) => extractPreviewContent(blog.translations[0], blog.createdAt)).filter((b: IBlogPreviewContent) => b && b.title && b.url);

      return previewContent;
    }
}

export default ExternalBlog;


// WEBPACK FOOTER //
// ../helpers/src/externalBlog/externalBlog.ts